module.exports = __webpack_public_path__ + "img/banner_left.c6647838.jpg";